import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function LatestUpdates() {
  const latest = movies.filter((m) => m.isNew).slice(0, 4);
  const allMovies = movies.slice(0, 8);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">
              <i className="ri-timer-flash-line text-primary-400 mr-2"></i>
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">刚出炉的热乎好片，别错过</p>
          </div>
        </div>

        {latest.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mb-8">
            {latest.map((movie) => (
              <Link
                key={movie.id}
                to={`/article/${movie.id}`}
                className="group relative overflow-hidden rounded-xl bg-background-100 border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
                data-product-shop
              >
                <div className="flex gap-4 p-4">
                  <div className="relative w-24 h-32 flex-shrink-0 rounded-lg overflow-hidden">
                    <img
                      src={movie.image}
                      alt={movie.title}
                      title={`秋霞影院 ${movie.title} 最新更新`}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <span className="absolute top-1 left-1 px-1.5 py-0.5 bg-primary-500 text-background-50 text-[10px] font-medium rounded whitespace-nowrap">
                      NEW
                    </span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-medium text-foreground-100 group-hover:text-primary-400 transition-colors truncate">
                      {movie.title}
                    </h3>
                    <div className="flex items-center gap-1.5 mt-1.5 text-xs text-foreground-500">
                      <span className="px-1.5 py-0.5 bg-background-200 rounded text-[10px]">{movie.quality}</span>
                      <span>{movie.subtype}</span>
                    </div>
                    <p className="text-xs text-foreground-600 mt-2 line-clamp-2">{movie.description}</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {allMovies.map((movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group cursor-pointer"
              data-product-shop
            >
              <div className="relative overflow-hidden rounded-lg aspect-[2/3] mb-3">
                <img
                  src={movie.image}
                  alt={movie.title}
                  title={`秋霞影院 ${movie.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-background-50/80 text-foreground-200 text-xs font-medium rounded-md whitespace-nowrap">
                    {movie.quality}
                  </span>
                </div>
                <div className="absolute bottom-2 right-2">
                  <span className="text-xs text-foreground-300 bg-background-50/80 px-1.5 py-0.5 rounded">
                    ★ {movie.rating}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-100 group-hover:text-accent-400 transition-colors truncate">
                {movie.title}
              </h3>
              <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
                <span>{movie.year}</span>
                <span>·</span>
                <span>{movie.subtype}</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 border border-background-200/50 rounded-lg text-sm font-medium text-foreground-300 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            浏览全部影片 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}